import * as MD from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { sendResetPasswordEmail } from '../../Store/ResetPassword/Actions';
import { IResetPasswordState } from '../../Store/ResetPassword/Types';
import { getTheme } from '../../Themes';

interface IPropsFromState {
	i18n: I18N;
	resetPassword: IResetPasswordState;
}

interface IState {
	email: string;
	username: string;
}

interface IPropsFromDispatch {
	sendResetPasswordEmail: typeof sendResetPasswordEmail;
}

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '40%',
		minWidth: '20%',
		marginTop: '50px',
	},
	cardContent: {
		width: '100%',
	},
	errorContainer: {
		width: '100%',
		justifyContent: 'center',
		textAlign: 'center',
		color: 'red',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	media: {
		height: 140,
	},
});

const DensedTextField = styled(MuiTextField)`
	.MuiInputBase-input {
		padding: 4px 6px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 300;
	}
`;

class ResetPasswordComponent extends React.Component<AllProps, IState> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			username: '',
			email: '',
		};
	}

	public render(): React.ReactNode {
		return (
			<div>
				{this.props.resetPassword.resetIsSucceed
					? this.success()
					: this.getForm()}
			</div>
		);
	}

	private success(): React.ReactNode {
		return (
			<React.Fragment>
				<p>un email de réinitialisation vient de vous être envoyé.</p>
				<p>
					votre nom d'utilisateur est : {this.state.username}{' '}
					{this.props.resetPassword.username}
				</p>
				<p>votre email est : {this.state.email}</p>
			</React.Fragment>
		);
	}

	private getForm(): React.ReactNode {
		return (
			<div>
				{this.props.resetPassword.recoveredUsernameIsMultiple
					? this.getUsername()
					: this.getEmail()}
			</div>
		);
	}

	private getEmail(): React.ReactNode {
		const { classes } = this.props;

		return (
			<form
				className={classes.form}
				noValidate={true}
				onSubmit={this.onSubmit.bind(this)}
			>
				<DensedTextField
					autoComplete="email"
					label={this.props.i18n._('Email')}
					onChange={this.onEmailChange.bind(this)}
					value={this.state.email}
					margin="normal"
					onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => {
						if (e.key === 'Enter') {
							this.onSubmit();
						}
					}}
				/>
				<MD.Button
					className={classes.button}
					color="primary"
					variant="contained"
					onClick={this.onSubmit.bind(this)}
				>
					{this.props.i18n._('Reset')}
				</MD.Button>

				{this.props.resetPassword.resetIsError !== '' ? (
					<MD.Grid className={classes.errorContainer}>
						{this.props.resetPassword.resetIsError}
					</MD.Grid>
				) : (
					''
				)}
			</form>
		);
	}

	private getUsername(): React.ReactNode {
		const { classes } = this.props;

		return (
			<form className={classes.form} noValidate={true}>
				<p>
					votre email est : <b>{this.state.email}</b>
				</p>
				<p>
					votre compte étant lié à plusieurs email, merci de bien
					vouloir spécifier l'utilisateur
				</p>
				<DensedTextField
					autoComplete="username"
					label={this.props.i18n._('Username')}
					onChange={this.onUsernameChange.bind(this)}
					value={this.state.username}
					margin="normal"
				/>
				<MD.Button
					className={classes.button}
					color="primary"
					variant="contained"
					onClick={this.onSubmit.bind(this)}
				>
					{this.props.i18n._('Reset')}
				</MD.Button>

				<MD.Link href="/login" variant="body2">
					Remember Password ?
				</MD.Link>
				{this.props.resetPassword.resetIsError !== '' ? (
					<MD.Grid className={classes.errorContainer}>
						{this.props.resetPassword.resetIsError}
					</MD.Grid>
				) : (
					''
				)}
			</form>
		);
	}

	private onEmailChange(ev: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ email: ev.target.value.toLowerCase() });
	}

	private onUsernameChange(ev: React.ChangeEvent<HTMLInputElement>) {
		this.setState({ username: ev.target.value.toLowerCase() });
	}

	private onSubmit() {
		if (this.state.email !== '') {
			this.props.sendResetPasswordEmail(
				this.state.email,
				this.state.username
			);
		}
	}
}

const mapStateToProps = ({
	i18n,
	layout,
	notificationBar,
	resetPassword,
}: IApplicationState) => ({
	i18n: i18n.i18n,
	layout,
	notificationBar,
	resetPassword,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	sendResetPasswordEmail: (e: string, u: string) =>
		dispatch(sendResetPasswordEmail(e, u)),
});

export const SendResetPassword = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(ResetPasswordComponent));
